import React, { useState, useEffect } from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  ModalFooter,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  Select,
  Button,
  Alert,
  AlertIcon,
  Image,
  useToast,
  Box,
  //useDisclosure
} from '@chakra-ui/react';

const SendNotificationBuilderModal = ({ isOpen, onClose, onSend }) => {
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  //const [image, setImage] = useState(null);
  const [imageUrl, setImageUrl] = useState('');
  const [audience, setAudience] = useState('all');
  const [error, setError] = useState('');
  const toast = useToast();

  useEffect(() => {
    if (isOpen) {
      setTitle('');
      setMessage('');
      //setImage(null);
      setImageUrl('');
      setAudience('all');
      setError('');
    }
  }, [isOpen]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      //setImage(file);
      setImageUrl(URL.createObjectURL(file));
    }
  };

  const handleSend = async () => {
    if (!title.trim()) {
      setError('Title is required.');
      return;
    }
    if (!message.trim()) {
      setError('Message is required.');
      return;
    }
  
    try {
      // Assuming 'imageUrl' is set after an image upload
      const response = await fetch('/api/send-notification', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          title,
          message,
          imageUrl, // Pass the image URL if an image is uploaded
          audience, // Selected audience (e.g., 'all', 'new_users', etc.)
        }),
      });
  
      if (response.ok) {
        toast({
          title: 'Notification Sent',
          description: 'Your message has been delivered.',
          status: 'success',
          duration: 4000,
          isClosable: true,
          position: 'top',
        });
  
        if (onSend) onSend({ title, message, imageUrl, audience });
        onClose();
      } else {
        setError('Failed to send notification.');
      }
    } catch (err) {
      setError('Failed to send notification.');
      console.error('Error sending notification:', err);
    }
  };  

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="md" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Send Notification</ModalHeader>
        <ModalCloseButton />
        <ModalBody pb={6}>
          {error && (
            <Alert status="error" mb={4}>
              <AlertIcon />
              {error}
            </Alert>
          )}

          <FormControl isRequired mb={4}>
            <FormLabel>Title</FormLabel>
            <Input
              placeholder="e.g. Promo Alert: Diaper 10% Off"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormControl>

          <FormControl isRequired mb={4}>
            <FormLabel>Message</FormLabel>
            <Textarea
              placeholder="Let your customers know about the promotion..."
              rows={4}
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Audience</FormLabel>
            <Select
              value={audience}
              onChange={(e) => setAudience(e.target.value)}
              placeholder="Select audience"
            >
              <option value="all">All Users</option>
              <option value="new_users">New Users</option>
              <option value="loyal_customers">Loyal Customers</option>
              <option value="targeted">Custom Audience</option>
            </Select>
          </FormControl>

          <FormControl mb={4}>
            <FormLabel>Upload Image</FormLabel>
            <Input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
            />
            {imageUrl && (
              <Box mt={3}>
                <Image
                  src={imageUrl}
                  boxSize="200px"
                  objectFit="cover"
                  borderRadius="md"
                  alt="Image Preview"
                />
              </Box>
            )}
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button onClick={onClose} mr={3}>
            Cancel
          </Button>
          <Button colorScheme="teal" onClick={handleSend}>
            Send
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SendNotificationBuilderModal;
